var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dida', { extra: !!_vm.extraSource }]},[_c('div',{staticClass:"dida__text",domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.extraSource)?_c('p',{staticClass:"dida__extra-source"},[_vm._v(_vm._s(_vm.extraSource))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }